import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/input/SelectField/SelectField';

const choices = [
    {
        id: 'in',
        name: 'resources.discounts.operators.labels.within',
    },
    {
        id: '<',
        name: 'resources.discounts.operators.labels.less_than',
    },
    {
        id: '<=',
        name: 'resources.discounts.operators.labels.equal_or_less_than',
    },
    {
        id: '>',
        name: 'resources.discounts.operators.labels.greater_than',
    },
    {
        id: '>=',
        name: 'resources.discounts.operators.labels.equal_or_greater_than',
    },
    {
        id: '===',
        name: 'resources.discounts.operators.labels.equal',
    },
    {
        id: '!==',
        name: 'resources.discounts.operators.labels.not_equal',
    },
    {
        id: 'or',
        name: 'resources.discounts.operators.labels.or',
    },
    {
        id: 'and',
        name: 'resources.discounts.operators.labels.and',
    },
];

const OperatorInputField = (props) => {
    const {
        floatingLabelFixed,
        fullWidth,
    } = props;

    return (
        <SelectField
            { ...props }
            choices={ choices }
            floatingLabelFixed={ floatingLabelFixed }
            fullWidth={ fullWidth }
            label='resources.discounts.operators.title'
            source='operator'
        />
    );
};

OperatorInputField.defaultProps = {
    floatingLabelFixed: true,
    fullWidth: false,
};

OperatorInputField.propTypes = {
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
};

export default OperatorInputField;



// WEBPACK FOOTER //
// ./src/components/input/OperatorInputField.js